import { render, staticRenderFns } from "./RecommendView.vue?vue&type=template&id=1e50373c&scoped=true&"
import script from "./RecommendView.vue?vue&type=script&lang=js&"
export * from "./RecommendView.vue?vue&type=script&lang=js&"
import style0 from "./RecommendView.vue?vue&type=style&index=0&id=1e50373c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50373c",
  null
  
)

export default component.exports